import { render, staticRenderFns } from "./detailListCard.vue?vue&type=template&id=5de486f2&scoped=true"
import script from "./detailListCard.vue?vue&type=script&lang=js"
export * from "./detailListCard.vue?vue&type=script&lang=js"
import style0 from "./detailListCard.vue?vue&type=style&index=0&id=5de486f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de486f2",
  null
  
)

export default component.exports